// Zentrale Aufzählungen. Werte sind stabil (DB-Enums), Labels sind UI-Text.
export const USER_ROLES = ['admin', 'editor', 'viewer'];
export const USER_ROLE_LABELS = {
    admin: 'Administrator',
    editor: 'Bearbeiter',
    viewer: 'Leser',
};
/** Wer darf schreiben? */
export const WRITE_ROLES = ['admin', 'editor'];
/** Wie eine Liste dargestellt wird – als Tabelle oder als Karten-Raster. */
export const LIST_VIEWS = ['list', 'grid'];
export const SEXES = ['female', 'male', 'other', 'unknown'];
export const SEX_LABELS = {
    female: 'weiblich',
    male: 'männlich',
    other: 'divers',
    unknown: 'unbekannt',
};
export const RELATIONSHIP_KINDS = ['parent', 'partner'];
export const PARENT_SUBTYPES = ['biological', 'adoptive', 'step', 'foster', 'guardian'];
export const PARENT_SUBTYPE_LABELS = {
    biological: 'biologisch',
    adoptive: 'adoptiert',
    step: 'Stiefkind',
    foster: 'Pflegekind',
    guardian: 'Vormundschaft',
};
export const PARTNER_SUBTYPES = ['married', 'partnership', 'unmarried', 'divorced', 'widowed'];
export const PARTNER_SUBTYPE_LABELS = {
    married: 'verheiratet',
    partnership: 'eingetragene Partnerschaft',
    unmarried: 'unverheiratet',
    divorced: 'geschieden',
    widowed: 'verwitwet',
};
export const RELATIONSHIP_SUBTYPES = [...PARENT_SUBTYPES, ...PARTNER_SUBTYPES];
export const RELATIONSHIP_SUBTYPE_LABELS = {
    ...PARENT_SUBTYPE_LABELS,
    ...PARTNER_SUBTYPE_LABELS,
};
export const EVENT_TYPES = [
    'birth',
    'baptism',
    'marriage',
    'divorce',
    'death',
    'burial',
    'residence',
    'occupation',
    'education',
    'emigration',
    'military',
    'other',
];
export const EVENT_TYPE_LABELS = {
    birth: 'Geburt',
    baptism: 'Taufe',
    marriage: 'Hochzeit',
    divorce: 'Scheidung',
    death: 'Tod',
    burial: 'Beerdigung',
    residence: 'Wohnort',
    occupation: 'Beruf',
    education: 'Ausbildung',
    emigration: 'Auswanderung',
    military: 'Militärdienst',
    other: 'Sonstiges',
};
export const MEDIA_KINDS = ['image', 'document', 'audio', 'video', 'other'];
export const MEDIA_KIND_LABELS = {
    image: 'Bild',
    document: 'Dokument',
    audio: 'Audio',
    video: 'Video',
    other: 'Sonstiges',
};
export const SOURCE_KINDS = [
    'registry',
    'document',
    'book',
    'newspaper',
    'letter',
    'family_record',
    'gravestone',
    'photo',
    'audio',
    'website',
    'interview',
    'other',
];
export const SOURCE_KIND_LABELS = {
    registry: 'Standesamt / Kirchenbuch',
    document: 'Urkunde / Dokument',
    book: 'Buch / Ortschronik',
    newspaper: 'Zeitung / Traueranzeige',
    letter: 'Brief / Postkarte',
    family_record: 'Familienstammbuch / Bibel',
    gravestone: 'Grabstein / Friedhof',
    photo: 'Foto',
    audio: 'Ton- oder Videoaufnahme',
    website: 'Website',
    interview: 'Mündliche Auskunft',
    other: 'Sonstiges',
};
// ── Familienfragen ─────────────────────────────────────────────────────────
export const QUESTION_KINDS = [
    'who_is_this',
    'missing_fact',
    'relationship',
    'more_media',
    'free',
];
export const QUESTION_KIND_LABELS = {
    who_is_this: 'Wer ist das?',
    missing_fact: 'Angabe',
    relationship: 'Verbindung',
    more_media: 'Bilder gesucht',
    free: 'Frage',
};
export const QUESTION_STATUSES = ['open', 'answered', 'resolved', 'closed'];
export const QUESTION_STATUS_LABELS = {
    open: 'offen',
    answered: 'beantwortet',
    resolved: 'übernommen',
    closed: 'geschlossen',
};
export const PROPOSAL_KINDS = ['none', 'person', 'fact', 'relationship'];
export const ANSWER_DECISIONS = ['pending', 'accepted', 'rejected'];
export const ANSWER_DECISION_LABELS = {
    pending: 'wartet auf Freigabe',
    accepted: 'übernommen',
    rejected: 'abgelehnt',
};
/**
 * Felder einer Person, die ein Vorschlag füllen darf. Bewusst eine kurze
 * Liste: alles hier drin muss die Übernahme auch schreiben können.
 */
export const PROPOSABLE_FIELDS = [
    'givenNames',
    'surname',
    'birth',
    'death',
    'birthPlace',
    'deathPlace',
    'occupation',
    'birthSurname',
    'nickname',
];
export const PROPOSABLE_FIELD_LABELS = {
    givenNames: 'Vorname(n)',
    surname: 'Nachname',
    birth: 'Geburtsdatum',
    death: 'Sterbedatum',
    birthPlace: 'Geburtsort',
    deathPlace: 'Sterbeort',
    occupation: 'Beruf',
    birthSurname: 'Geburtsname',
    nickname: 'Rufname',
};
/** Welche Art von Wert ein Feld erwartet – steuert das Eingabefeld. */
export const PROPOSABLE_FIELD_TYPES = {
    givenNames: 'text',
    surname: 'text',
    birth: 'date',
    death: 'date',
    birthPlace: 'place',
    deathPlace: 'place',
    occupation: 'text',
    birthSurname: 'text',
    nickname: 'text',
};
/**
 * Rolle einer vorgeschlagenen Verbindung, immer aus Sicht der Person, um die
 * es in der Frage geht: „X ist Elternteil von ihr", „X ist ihr Kind", „X ist
 * ihr Partner".
 */
export const RELATION_ROLES = ['parent', 'child', 'partner'];
export const RELATION_ROLE_LABELS = {
    parent: 'Elternteil von',
    child: 'Kind von',
    partner: 'Partner(in) von',
};
// ── Lücken / Aufgaben ──────────────────────────────────────────────────────
/**
 * Was im Archiv fehlt, als konkrete Aufgabe gedacht – nicht als Statistik.
 * Bewusst kurz gehalten: jede Art muss eine Handlung nach sich ziehen, die in
 * einer Minute erledigt ist. „Beruf fehlt“ wäre zwar wahr, würde die Liste
 * aber mit Kleinkram fluten.
 */
export const GAP_KINDS = [
    'face',
    'birth',
    'death',
    'birthPlace',
    'parents',
    'media',
    'unmarkedImage',
];
/** Was fehlt. */
export const GAP_KIND_LABELS = {
    face: 'Name zum Gesicht',
    birth: 'Geburtsdatum',
    death: 'Sterbedatum',
    birthPlace: 'Geburtsort',
    parents: 'Eltern',
    media: 'Foto',
    unmarkedImage: 'Markierungen',
};
/** Was zu tun ist – die Aufgabe in Befehlsform. */
export const GAP_KIND_TASKS = {
    face: 'Gesicht benennen',
    birth: 'Geburtsdatum eintragen',
    death: 'Sterbedatum eintragen',
    birthPlace: 'Geburtsort eintragen',
    parents: 'Eltern verknüpfen',
    media: 'Foto zuordnen',
    unmarkedImage: 'Personen im Bild markieren',
};
/** Lücken, die sich direkt in der Liste ausfüllen lassen. */
export const GAP_FIELDS = {
    birth: 'birth',
    death: 'death',
    birthPlace: 'birthPlace',
};
/**
 * Wie alt ein Mensch auf einem Bild *aussieht* – die Antwort eines Betrachters,
 * nicht die einer Maschine.
 *
 * Warum die Stufe gespeichert wird und nicht die Jahreszahlen: gespeichert
 * gehört, was der Mensch gesagt hat. „Sieht aus wie ein Kind" bleibt wahr,
 * auch wenn wir die Spanne für „Kind" später anders ziehen; ein daraus
 * gerechnetes „3 bis 12" wäre dann eine Aussage, die niemand getroffen hat.
 *
 * Warum so breite Stufen: sie sollen *verlässlich* sein. Ob jemand 34 oder 38
 * ist, sieht man einem Scan nicht an; ob jemand ein Kind ist oder ein
 * mittelalter Mensch, sieht man sofort. Die Genauigkeit steckt nicht in der
 * Stufe, sondern darin, dass die Antwort stimmt.
 *
 * Die stärkste Stufe ist die erste: ein Säugling datiert ein Bild auf drei
 * Jahre – enger als jede andere Auskunft, die dieses Archiv über ein
 * undatiertes Foto hat.
 */
export const APPARENT_AGES = ['baby', 'child', 'teen', 'young', 'middle', 'old'];
/** Die Spanne in Jahren je Stufe – beide Grenzen einschließlich. */
export const APPARENT_AGE_YEARS = {
    baby: { from: 0, to: 2 },
    child: { from: 3, to: 12 },
    teen: { from: 13, to: 19 },
    young: { from: 20, to: 35 },
    middle: { from: 36, to: 55 },
    old: { from: 56, to: 100 },
};
/** Die Beschriftung der Knöpfe – kurz, weil sechs davon nebeneinander stehen. */
export const APPARENT_AGE_LABELS = {
    baby: 'Säugling',
    child: 'Kind',
    teen: 'Jugendlich',
    young: 'jung',
    middle: 'mittel',
    old: 'alt',
};
/** Ganz ausgeschrieben, für Begründungen und Hilfetexte. */
export function apparentAgeLabel(age) {
    const span = APPARENT_AGE_YEARS[age];
    return `${APPARENT_AGE_LABELS[age]} (${span.from}–${span.to} Jahre)`;
}
/**
 * Der Vergleich zweier Gesichter derselben Person: Wer ist jünger?
 *
 * Die verlässlichste Auskunft, die ein Betrachter über das Alter geben kann –
 * und zwar deutlich verlässlicher als eine Altersstufe. „Wie alt sieht sie hier
 * aus?" hat keine Antwort, die man am Bild ablesen kann; „auf welchem der
 * beiden ist sie jünger?" hat eine, und fast jeder trifft sie richtig.
 *
 * Der eigentliche Gewinn liegt aber woanders: dieser Vergleich braucht **kein
 * Geburtsjahr**. Ist das Vergleichsbild datiert, folgt aus „hier ist sie
 * jünger" unmittelbar „dieses Bild ist früher" – ohne dass jemand wissen muss,
 * wie alt sie auf einem der beiden war. Damit greift er auch bei Personen, über
 * die das Archiv sonst nichts weiß.
 *
 * Die Richtung gilt immer von der *befragten* Markierung aus: `younger` heißt
 * „auf diesem Bild jünger als auf dem Vergleichsbild".
 */
export const AGE_COMPARISONS = ['younger', 'same', 'older', 'unsure'];
/** Beschriftung der drei Knöpfe – plus die Absage. */
export const AGE_COMPARISON_LABELS = {
    younger: 'jünger',
    same: 'gleich alt',
    older: 'älter',
    unsure: 'kann ich nicht sagen',
};
/**
 * Wie weit „gleich alt" reicht, in Jahren nach beiden Seiten.
 *
 * Zwei Aufnahmen im Abstand von drei Jahren sehen bei einem Erwachsenen gleich
 * aus – wer „gleich alt" sagt, meint also nicht „dasselbe Jahr". Die schwächste
 * der drei Antworten, und die einzige mit einer Annahme darin.
 */
export const SAME_AGE_TOLERANCE = 3;
/**
 * Kleinster Altersabstand, ab dem ein Vergleich überhaupt gestellt wird.
 *
 * Zwei Bilder aus benachbarten Jahren zu vergleichen ist ein Münzwurf, und ein
 * Münzwurf, den jemand als Beobachtung einträgt, ist schlimmer als keine
 * Angabe. Gefragt wird nur, wo eine Antwort möglich ist.
 */
export const MIN_COMPARISON_GAP = 5;
/**
 * Woher das Aufnahmedatum eines Bildes kommt.
 *
 *  - `exif`     – aus der Datei gelesen, beim Verarbeiten des Uploads.
 *  - `manual`   – von einem Menschen eingetragen. Wird nie überschrieben.
 *  - `estimate` – aus den Personen im Bild geschlossen und übernommen. Nur
 *    diese Herkunft darf eine spätere, bessere Schätzung wieder anfassen.
 */
export const TAKEN_AT_SOURCES = ['exif', 'manual', 'estimate'];
export const CITABLE_ENTITIES = ['person', 'relationship', 'event', 'media'];
/** Bildgrößen, die beim Upload erzeugt werden. */
export const IMAGE_VARIANTS = {
    thumb: { width: 320, height: 320 },
    medium: { width: 1024, height: 1024 },
    large: { width: 2048, height: 2048 },
};
/**
 * Wie viele Gesichter ein Erkennungslauf höchstens anlegen darf.
 *
 * Auch ein Klassenfoto bleibt darunter. Die Grenze ist keine Fachregel,
 * sondern eine Bremse: fände das Modell auf einem Bild mit Muster (Tapete,
 * Kiesweg) hundert Gesichter, entstünden sonst hundert Rahmen, die jemand
 * einzeln wieder löschen müsste.
 */
export const MAX_DETECTED_FACES = 60;
/**
 * Länge der Merkmalsreihe eines Gesichts – die Ausgabe von SFace.
 *
 * Steht hier und nicht im Datenbankschema, weil beide Seiten sie brauchen und
 * sie zwingend übereinstimmen müssen: der Browser rechnet die Reihe, Postgres
 * legt sie in eine `vector(n)`-Spalte. Weichen die Zahlen ab, scheitert erst
 * das Einfügen – zur Laufzeit, nicht beim Übersetzen.
 */
export const FACE_EMBEDDING_DIMENSIONS = 128;
/**
 * Kennung des Modells, das die Merkmalsreihen erzeugt. Wird zu jeder Reihe
 * mitgeschrieben; Vektoren verschiedener Modelle sind nicht vergleichbar.
 *
 * Die Kennung ist gleichzeitig der Auslöser für das Nachrechnen: ändert sie
 * sich, gelten alle vorhandenen Reihen als veraltet und der Nachlauf holt sie
 * neu. Deshalb steht auch das Spiegeln im Namen – es verändert die Zahlen.
 */
export const FACE_EMBEDDING_MODEL = 'sface-2021dec-fp32-flip';
export const PAGE_SIZES = [25, 50, 100];
export const DEFAULT_PAGE_SIZE = 25;
// ── Änderungsprotokoll ─────────────────────────────────────────────────────
export const AUDIT_ACTIONS = [
    'create',
    'update',
    'delete',
    'login',
    'logout',
    'upload',
    'invite',
    'password',
];
/** Was geschehen ist – als Partizip, damit „Person X angelegt“ trägt. */
export const AUDIT_ACTION_LABELS = {
    create: 'angelegt',
    update: 'geändert',
    delete: 'gelöscht',
    upload: 'hochgeladen',
    login: 'angemeldet',
    logout: 'abgemeldet',
    invite: 'eingeladen',
    password: 'Passwort geändert',
};
/**
 * Dieselben Vorgänge als Substantiv – im Filter steht kein Satz, in dem ein
 * Partizip trägt („angelegt“ allein liest sich als Zustand, nicht als Auswahl).
 */
export const AUDIT_ACTION_FILTER_LABELS = {
    create: 'Anlegen',
    update: 'Bearbeiten',
    delete: 'Löschen',
    upload: 'Hochladen',
    login: 'Anmeldung',
    logout: 'Abmeldung',
    invite: 'Einladung',
    password: 'Passwortänderung',
};
/**
 * Woran etwas geschehen ist. Die Liste ist die Auswahl im Aktivitätsfilter –
 * deshalb als Array, damit die Reihenfolge feststeht, und mit typisiertem
 * Labelobjekt, damit ein neuer Typ ohne Beschriftung nicht durchrutscht.
 */
export const AUDIT_ENTITY_TYPES = [
    'person',
    'relationship',
    'event',
    'place',
    'media',
    'region',
    'source',
    'question',
    'answer',
    'user',
    'invite',
    'archive',
];
export const AUDIT_ENTITY_LABELS = {
    person: 'Person',
    relationship: 'Beziehung',
    event: 'Ereignis',
    place: 'Ort',
    media: 'Medium',
    region: 'Markierung',
    source: 'Quelle',
    user: 'Benutzer',
    invite: 'Einladung',
    question: 'Frage',
    answer: 'Antwort',
    archive: 'Archiv',
};
/**
 * Feldnamen im Protokoll. Bewusst über alle Entitäten hinweg in einer Tabelle:
 * `start` heißt bei einer Beziehung dasselbe wie bei einem Ereignis, und ein
 * unbekannter Schlüssel fällt einfach auf sich selbst zurück.
 */
export const AUDIT_FIELD_LABELS = {
    // Person
    givenNames: 'Vorname(n)',
    surname: 'Nachname',
    birthSurname: 'Geburtsname',
    nickname: 'Rufname',
    sex: 'Geschlecht',
    isLiving: 'Lebt',
    isUnverified: 'Noch nicht bestätigt',
    birth: 'Geburt',
    death: 'Tod',
    birthPlaceId: 'Geburtsort',
    deathPlaceId: 'Sterbeort',
    occupation: 'Beruf',
    notes: 'Notizen',
    avatarMediaId: 'Porträt',
    // Beziehung
    subtype: 'Art',
    start: 'Beginn',
    end: 'Ende',
    placeId: 'Ort',
    // Ereignis
    type: 'Art',
    title: 'Titel',
    date: 'Datum',
    description: 'Beschreibung',
    personIds: 'Beteiligte',
    relationshipId: 'Beziehung',
    // Medium
    detectedFaces: 'Automatisch erkannte Gesichter',
};
//# sourceMappingURL=constants.js.map